class ConfirmOTPResponse {
  constructor (obj) {
    this.acaoPermitidaParaPlanoEscolhidoEnum = AcaoPermitidaParaPlanoEscolhidoEnum[obj.acaoPermitidaParaPlanoEscolhidoEnum]
  }
}

const AcaoPermitidaParaPlanoEscolhidoEnum = {
  TROCA: 'TROCA',
  ADESAO: 'ADESAO',
  NENHUMA: 'NENHUMA'
}

export {
  ConfirmOTPResponse, AcaoPermitidaParaPlanoEscolhidoEnum
}
